<!--
 * @Author: your name
 * @Date: 2021-07-12 16:29:48
 * @LastEditTime: 2021-09-23 16:13:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\allCategoriesDialog.vue
-->
<template>
  <div>
    <el-dialog
     :append-to-body="true"
      title="全部分类"
      width="600px"
      :visible.sync="dialogVisible"
      @close='closeDialog'>
      <div class="dialog-content">
            <div>
                <div class="btn-list">
                    <el-button type="primary" @click="addItem('',1)">增加一级类目</el-button>
                </div>
                <div class="content-div">
                    <el-tree
                        :data="allCategoriesList"
                        node-key="id"
                        default-expand-all
                        :expand-on-click-node="false">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span class="label-name">{{ node.label }}</span>
                            <span class="handle-btn">
                            <el-button
                               v-if="data.children"
                                type="text"
                                size="mini"
                                @click="addItem(data,2)"
                                >新增
                            </el-button>
                             <el-button
                                type="text"
                                size="mini"
                                @click=" editItem(node,data)"
                                >编辑
                            </el-button>
                            <el-button
                                type="text"
                                size="mini"
                                @click=" remove(node, data)">删除
                            </el-button>
                            
                            </span>
                        </span>
                    </el-tree>
                </div>
                 
            </div>
           
       </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sunbmitallCategoriesList">确 定</el-button>
        </div>
      
    </el-dialog>
      <!-- 选择类目弹窗 -->
   
    <!-- <companyCategoryDialog :categoryVisible.sync="companyCategoryVisible"  @getCategoryInfo="getCompanyCategoryInfo"></companyCategoryDialog> -->
    <shopCategoryDialog :categoryVisible.sync="companyCategoryVisible"  @getCategoryInfo="getCompanyCategoryInfo"></shopCategoryDialog> 
    <el-dialog      :append-to-body="true" :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="类目名称：" maxlength="6" show-word-limit label-width="120px" prop="name">
          <el-input v-model.trim="formData.name" autocomplete="off"></el-input>
        </el-form-item>
 
        <el-form-item label="关联平台类目：" label-width="120px" v-if="(dialogTitle=='新增类目'&&this.activeData.level>1) || dialogTitle=='编辑类目'&&this.activeData.level>2">
            <div>
              <el-tag
                class="tag-btn"
                  v-for="(tag,index) in this.formData.categoryList"
                  :key="tag.categoryId"
                  closable
                  @close='removeCategory(index)'>
                  {{tag.categoryName}}
              </el-tag>
            </div>
            
          <el-button type="warning" size="mini" @click="companyCategoryVisible=true">关联类目</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitData('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import categoryDialog from "../../components/category/categoryDialog.vue";
// import companyCategoryDialog from "../../components/category/companyCategoryDialog.vue";
import shopCategoryDialog from "../../components/category/shopCategoryDialog.vue";

//  let KEY=new Date().getTime();
export default {
   props:{
        activeName: {
            type: String,
            default: ''
        },
        allCategoriesList:{
          type: Array,
          default: function () {
            return []
          }
        },
  },
  components:{
    // categoryDialog,
    // companyCategoryDialog
    shopCategoryDialog
  },
  data(){
      return {
          dialogVisible:false,
 
          dialogTitle:'',
          dialogFormVisible:false,
          formData:{
            name:'',
            categoryList:[]
          },
          activeData:'',
          activeNode:'',
          activeType:'',
          rules: {
            name: [
              { required: true, message: '请输入类目名称', trigger: 'blur' },
              { min: 2,  message: '长度最少2个字符', trigger: 'blur' }
            ]
          },
          companyCategoryVisible:false
      }
  },
  watch: {
        activeName(newV,oldV) {
            console.log(newV,oldV)
            this.dialogVisible= newV=='allCategories'?true:false
        } 
},
 
  methods: {
      // type 1、父级  2、子级
      addItem(data,type){
        this.activeData=data;
        this.activeType=type;
        this.dialogTitle='新增类目';
        this.formData.categoryList=[]
        this.formData.name='';
        this.dialogFormVisible=true;
      },
      editItem(node,data){
        this.activeNode=node;
        this.activeData=data;
        this.dialogTitle='编辑类目';
        this.formData.name=data.label;
        this.formData.categoryList=data.categoryList?data.categoryList:[];
        this.dialogFormVisible=true;
      },
      submitData(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.dialogTitle=='新增类目'){
              this.append();
            }else if(this.dialogTitle=='编辑类目'){
              this.editTree()
            }
            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      //校验同级类别名称是否重复
      checkName(arr,name,key){
        let isOk=true;
        arr.forEach(item=>{
          if(item.label==name && item.key!=key){
            this.$message({
                type:'error',
                message:'类目名称不能重复！'
            })
            isOk=false
          }
        })
        return isOk
         
      },
      append() {
        this.dialogFormVisible=false;
        if(this.activeType==1){
          let newChild = {
            key:new Date().getTime(), 
            label:this.formData.name, 
            level:1,
            children: [],
          };
          if(this.checkName(this.allCategoriesList,this.formData.name)){
            this.allCategoriesList.push(newChild)
          }
        }else if(this.activeType==2){
          let level=this.activeData.level
          const newChild = {
            key: new Date().getTime(), 
            label:this.formData.name,
            level:this.activeData.level+1,
            categoryList:this.formData.categoryList
          };
          if(level<2){
            newChild.children=[]
          }
          if(this.checkName(this.activeData.children,this.formData.name)){
            this.activeData.children.push(newChild);
          }
        
        }
      },
      editTree() {
          if(this.activeNode.parent.data.children){
             if(this.checkName(this.activeNode.parent.data.children,this.formData.name,this.activeNode.data.key)){
                this.dialogFormVisible=false;
                this.activeData.label=this.formData.name;
                this.activeData.categoryList=this.formData.categoryList;
              }
          }else{
            if(this.checkName(this.allCategoriesList,this.formData.name,this.activeNode.data.key)){
                this.dialogFormVisible=false;
                this.activeData.label=this.formData.name;
                this.activeData.categoryList=this.formData.categoryList;
             }
          }
         
         
      },
      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.key === data.key);
        children.splice(index, 1);
      },
    closeDialog(){
        this.$parent.choosenComments('');
    },
    removeCategory(index){
      this.formData.categoryList.splice(index, 1)
    },
    // 得到所选类目的信息
    
    getCompanyCategoryInfo(arr){
      console.log(arr)
      arr.forEach(list=>{
        let isOK=true;
        this.formData.categoryList.forEach(item=>{
          if(item.categoryId==list.categoryId){
            isOK=false;
            this.$message({
                type:'error',
                message:`类目${list.categoryName}已存在！`
            })
          }
        })
        if(isOK){
          this.categoryVisible=false;
          this.formData.categoryList.push(list)
        }
      })
    },
    sunbmitallCategoriesList(){
      this.dialogVisible=false;
    }
     
   
 
  }
};
</script>
<style lang="scss" scoped>
.content-div{
    width:100%;
    padding:10px;
    height:300px;
 
    margin-top: 10px;
    border-radius: 10px;
    overflow: auto;
    .custom-tree-node{
        width: 100%;
        .label-name{
            line-height: 28px;
        }
        
         .handle-btn{
             float: right;
            align-items: center;
         }
    }
}
.tag-btn{
  margin-right: 10px;
}
</style>
